document.addEventListener('DOMContentLoaded', function () {
  const windowWidth = $(window).width();
  const SPLIDE_SLIDE = '.splide__slide'
  const ARTICLE_BLOG_CARD_SELECTOR = '.splide--article-related-blog';
  const ARTICLE_PRODUCT_CARD_SELECTOR = '.splide--article-recommended-product';
  const articleBlogCard = ($(ARTICLE_BLOG_CARD_SELECTOR).find($(SPLIDE_SLIDE))).length;
  const articleProductCard = ($(ARTICLE_PRODUCT_CARD_SELECTOR).find($(SPLIDE_SLIDE))).length;

  
  $('.article-related-blog__wrapper').each(function() {
    var article_length = $(this).find(".splide__slide").length;
    var pagin = false;
    if(article_length > 3){
      var pagin = true;
    }
    var splide_article = $(this).find('.js-splide-article-blog').attr('data-splide');

    if ((windowWidth < 768 && article_length > 1) || (windowWidth >= 768 && article_length > 3)) {
      new Splide(splide_article, {
        type: 'loop',
        perPage: 3,
        gap: '29px',
        speed: '400',
        keyboard: 'true',
        updateOnMove: 'true',
        focus: 'left',
        arrows: false,
        breakpoints: {
          767: {
            perPage: 1
          }
        }
      }).mount();
    }
  })

  $('.article-recommended-product__wrapper').each(function() {
    var articleProductCard = $(this).find('.splide__slide').length;
    var splide_article = $(this).find('.js-splide-article-product').attr('data-splide');
    if ((windowWidth < 768 && articleProductCard > 1) || (windowWidth >= 768 && articleProductCard > 3)) {
      new Splide(splide_article, {
        type: 'loop',
        perPage: 3,
        gap: '29px',
        speed: '400',
        keyboard: 'true',
        updateOnMove: 'true',
        arrows: false,
        breakpoints: {
          767: {
            perPage: 1
          }
        }
      }).mount();
    }
  });
});

jQuery(document).ready(function(){ 
  $('.product-payment .laybuy-payment').on('click', function () {
    $('.laybuy-logo-and-text .laybuy-link')[0].click();
  });
})